import { DueInvoiceCalculateDTO, DueInvoiceDTO, DueInvoiceScheduleDTO } from './../models/dueInvoice.model';
import { TwoCLogDTO } from './../models/twoCLog.model';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { LinqPredicateDTO } from "../models/linqPredicate.model";

@Injectable({
  providedIn: 'root'
})

export class DocumentCDVEventService {

  constructor(private http: HttpClient) {
  }

  getdocumentCDVEvents(fk_company: number, id: number=0,ispassivedocument:boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/DocumentCDVEvents/GetDocumentCDVEvents/" + fk_company +"/" + id + "/" + ispassivedocument).toPromise();
  }

  getCDVStatusReasonsAvailable(statuscode: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/DocumentCDVEvents/GetCDVStatusReasonsAvailable/" + statuscode).toPromise();
  }
    
}
